/**
 *
 */
(function() {
    'use strict';
    angular.module('cbl.common').directive('mitomNumeric', [
        '$parse',
        '$filter',
        function($parse, $filter) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, elem, attrs, ctrl) {
                    var maxValue = attrs.ccMax;
                    var minValue = attrs.ccMin;
                    var precision = attrs.ccPrecisione ?
                        attrs.ccPrecisione.split(',') :
                        null;
                    if (precision) {
                        if (
                            precision.length < 2 ||
                            parseFloat(precision[0]) === NaN ||
                            parseFloat(precision[1]) === NaN
                        ) {
                            precision = null;
                        }
                    }
                    var integerValue = attrs.ccInt === '';

                    // For DOM -> model validation
                    ctrl.$parsers.unshift(function(value) {
                        if (!value || value === '') {
                            return value;
                        }
                        value = manipolaNumerico(value);
                        // comma to decimal
                        value = value ?
                            value.toString().trim().replace('.', '').replace(',', '.') :
                            null;
                        if (maxValue) {
                            maxValue = maxValue.replace(',', '.');
                            // controllo su valore massimo
                            ctrl.$setValidity(
                                'ccMax', !(parseFloat(value) > parseFloat(maxValue))
                            );
                        }
                        if (minValue) {
                            minValue = minValue.replace(',', '.');
                            // controllo su valore minimo
                            ctrl.$setValidity(
                                'ccMin', !(parseFloat(value) < parseFloat(minValue))
                            );
                        }

                        return parseFloat(value);
                    });

                    // For model -> DOM validation

                    ctrl.$formatters.unshift(function(value) {
                        if (!value || value === '') {
                            return value;
                        }
                        // decimal to comma
                        value = value ? value.toString().replace('.', ',') : null;
                        value = manipolaNumerico(value);
                        if (maxValue) {
                            maxValue = maxValue.replace('.', ',');
                            // controllo su valore massimo
                            ctrl.$setValidity(
                                'ccMax', !(parseFloat(value) > parseFloat(maxValue))
                            );
                        }
                        if (minValue) {
                            minValue = minValue.replace('.', ',');
                            // controllo su valore minimo
                            ctrl.$setValidity(
                                'ccMin', !(parseFloat(value) < parseFloat(minValue))
                            );
                        }

                        // formatta migliaia
                        // var splitedValue = value.split(',');
                        // var counter = 0;
                        // for (var i = splitedValue[0].length - 1; i >= 1; i--) {
                        //     counter++;
                        //     if (counter % 3 == 0) {
                        //         splitedValue[0] = splitedValue[0].slice(0, i) + '.' + splitedValue[0].slice(i);
                        //     }
                        // }
                        // value = splitedValue[0] + (splitedValue.length === 1 ? '' : (',' + splitedValue[1]));

                        return value;
                    });

                    var manipolaNumerico = function(value) {
                        if (!value) {
                            return value;
                        }
                        var validi;
                        if (integerValue) {
                            validi = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-'];
                        } else {
                            validi = [
                                '0',
                                '1',
                                '2',
                                '3',
                                '4',
                                '5',
                                '6',
                                '7',
                                '8',
                                '9',
                                ',',
                                '-'
                            ];
                        }

                        var lung = value.length;
                        for (var i = lung - 1; i >= 0; i--) {
                            var ch = value.charAt(i);
                            if (i !== 0 && ch === '-') {
                                // rimuovo il segno negativo se non
                                // è all'inizio
                                value = value.substring(0, i) + value.substring(i + 1);
                                continue;
                            }
                            var valoreValido = false;
                            for (var j in validi) {
                                if (ch === validi[j]) {
                                    valoreValido = true;

                                    break;
                                }
                            }
                            if (!valoreValido) {
                                value = value.substring(0, i) + value.substring(i + 1);
                            }
                        }
                        if (precision) {
                            var splittedValue = value.split(',');
                            var decimalsAllowed = precision[1].length;
                            if (
                                splittedValue[1] &&
                                splittedValue[1].length > decimalsAllowed
                            ) {
                                splittedValue[1] = splittedValue[1].slice(0, decimalsAllowed);

                                value = splittedValue.join(',');
                            }
                        }

                        return value;
                    };

                    elem.on('keyup', function(data) {
                        var start = this.selectionStart,
                            end = this.selectionEnd;
                        var value = this.value;

                        this.value = manipolaNumerico(value);
                        this.setSelectionRange(start, end);
                    });
                }
            };
        }
    ]);
})();